/**
 * Jump Nav
 * Auto-generates sticky navigation from H2 headings on the page.
 * Handles sticky offset, active section tracking, and scroll-fade overlays.
 */

class JumpNav {
	constructor() {
		this.nav       = document.querySelector( '.jump-nav' );
		if ( ! this.nav ) return;

		this.menu      = this.nav.querySelector( '.jump-nav__menu' );
		this.menuWrap  = this.nav.querySelector( '.jump-nav__menu-wrap' );
		this.select    = this.nav.querySelector( '.jump-nav__select' );
		this.sections  = [];
		this.activeIdx = -1;

		this.init();
	}

	init() {
		this.buildFromHeadings();
		if ( ! this.sections.length ) return;

		this.setStickyOffsets();
		this.bindEvents();
		this.updateFades();
		this.updateActiveOnScroll();
	}

	buildFromHeadings() {
		const scope    = document.querySelector( '.basic-page' ) || document.body;
		const headings = Array.from( scope.querySelectorAll( 'h2' ) ).filter(
			h2 => ! this.nav.contains( h2 ) &&
				! h2.closest( '.action-card' ) &&
				! h2.closest( '.bio-card-grid' ) &&
				! h2.closest( '.cta-banner' ) &&
				! h2.closest( '.calendar-modal' ) &&
				! h2.closest( '.bio-modal' )
		);

		headings.forEach( ( h2, i ) => {
			if ( ! h2.id ) {
				const slug = h2.textContent.trim()
					.toLowerCase()
					.replace( /[^a-z0-9]+/g, '-' )
					.replace( /^-|-$/g, '' );
				h2.id = slug || ( 'section-' + i );
			}

			this.sections.push( { id: h2.id, label: h2.textContent.trim(), el: h2 } );

			// Link item
			const li  = document.createElement( 'li' );
			li.className = 'jump-nav__item';

			const a          = document.createElement( 'a' );
			a.href           = '#' + h2.id;
			a.className      = 'jump-nav__link';
			a.textContent    = h2.textContent.trim();
			a.setAttribute( 'aria-current', 'false' );
			a.addEventListener( 'click', e => this.handleLinkClick( e, h2 ) );
			li.appendChild( a );

			this.menu.appendChild( li );

			// Select option
			const opt       = document.createElement( 'option' );
			opt.value       = '#' + h2.id;
			opt.textContent = h2.textContent.trim();
			this.select.appendChild( opt );
		} );
	}

	handleLinkClick( e, target ) {
		e.preventDefault();
		target.scrollIntoView( { behavior: 'smooth', block: 'start' } );
	}

	setStickyOffsets() {
		const header  = document.querySelector( '.site-header' );
		const setVars = () => {
			const headerH = header ? header.getBoundingClientRect().height : 0;
			const navH    = this.nav.getBoundingClientRect().height;
			document.documentElement.style.setProperty( '--jump-nav-top', headerH + 'px' );
			// scroll-padding-top ensures anchors land below both sticky bars
			document.documentElement.style.setProperty( 'scroll-padding-top', ( headerH + navH + 8 ) + 'px' );
		};
		setVars();
		window.addEventListener( 'resize', setVars );
	}

	bindEvents() {
		this.select.addEventListener( 'change', () => {
			const el = document.getElementById( this.select.value.replace( '#', '' ) );
			if ( el ) el.scrollIntoView( { behavior: 'smooth', block: 'start' } );
		} );

		this.menu.addEventListener( 'scroll', () => this.updateFades(), { passive: true } );

		window.addEventListener( 'scroll', () => this.updateActiveOnScroll(), { passive: true } );
	}

	updateFades() {
		if ( ! this.menu || ! this.menuWrap ) return;
		const { scrollLeft, scrollWidth, clientWidth } = this.menu;
		this.menuWrap.classList.toggle( 'jump-nav__menu-wrap--fade-left',  scrollLeft > 2 );
		this.menuWrap.classList.toggle( 'jump-nav__menu-wrap--fade-right', scrollLeft < scrollWidth - clientWidth - 2 );
	}

	updateActiveOnScroll() {
		const offset = this.nav.getBoundingClientRect().bottom + 16;
		let idx = 0;

		this.sections.forEach( ( section, i ) => {
			if ( section.el.getBoundingClientRect().top <= offset ) idx = i;
		} );

		this.setActive( idx );
	}

	setActive( idx ) {
		if ( this.activeIdx === idx ) return;
		this.activeIdx = idx;

		const links = this.menu.querySelectorAll( '.jump-nav__link' );

		links.forEach( ( link, i ) => {
			const isActive = i === idx;
			link.classList.toggle( 'jump-nav__link--active', isActive );
			link.setAttribute( 'aria-current', isActive ? 'location' : 'false' );
		} );

		if ( this.select && this.sections[ idx ] ) {
			this.select.value = '#' + this.sections[ idx ].id;
		}

		// Scroll active link into view within the menu (horizontal scroll only)
		if ( links[ idx ] ) {
			const menuRect = this.menu.getBoundingClientRect();
			const linkRect = links[ idx ].getBoundingClientRect();
			if ( linkRect.left < menuRect.left ) {
				this.menu.scrollLeft -= menuRect.left - linkRect.left + 16;
			} else if ( linkRect.right > menuRect.right ) {
				this.menu.scrollLeft += linkRect.right - menuRect.right + 16;
			}
		}
	}
}

new JumpNav();
